"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.portfoliosMovementsQuery = exports.portfolioMovementsQuery = exports.portfolioQuery = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const types_1 = require("../types");
/**
 * @hidden
 *
 * Get portfolio details for a given DID and portfolio number
 */
function portfolioQuery(variables) {
    const query = (0, graphql_tag_1.default) `
    query PortfolioQuery($identityId: String!, $number: Int!) {
      portfolios(filter: { identityId: { equalTo: $identityId }, number: { equalTo: $number } }) {
        nodes {
          eventIdx
          createdBlock {
            blockId
            datetime
            hash
          }
        }
      }
    }
  `;
    return {
        query,
        variables,
    };
}
exports.portfolioQuery = portfolioQuery;
/**
 *  @hidden
 */
function createPortfolioMovementFilters({ identityId, portfolioId, assetId: ticker, address }, queryAll) {
    const args = ['$fromId: String!, $toId: String!'];
    const fromIdFilters = queryAll
        ? ['fromId: { startsWith: $fromId }']
        : ['fromId: { equalTo: $fromId }'];
    const toIdFilters = queryAll ? ['toId: { startsWith: $toId }'] : ['toId: { equalTo: $toId }'];
    const portfolioNumber = portfolioId ? portfolioId.toNumber() : 0;
    const variables = {
        fromId: queryAll ? `${identityId}` : `${identityId}/${portfolioNumber}`,
        toId: queryAll ? `${identityId}` : `${identityId}/${portfolioNumber}`,
    };
    if (ticker) {
        variables.assetId = ticker;
        args.push('$assetId: String!');
        const assetIdFilter = 'assetId: { equalTo: $assetId }';
        toIdFilters.push(assetIdFilter);
        fromIdFilters.push(assetIdFilter);
    }
    if (address) {
        variables.address = address;
        args.push('$address: String!');
        const addressFilter = 'address: { equalTo: $address }';
        toIdFilters.push(addressFilter);
        fromIdFilters.push(addressFilter);
    }
    return {
        args: `(${args.join()})`,
        filter: `filter: { or: [ { ${fromIdFilters.join()} }, { ${toIdFilters.join()} } ] }`,
        variables,
    };
}
/**
 * @hidden
 */
function buildPortfolioMovementsQuery(paddedIds, args, filter) {
    const orderBy = paddedIds
        ? `${types_1.PortfolioMovementsOrderBy.CreatedBlockIdAsc}`
        : `${types_1.PortfolioMovementsOrderBy.CreatedAtAsc}, ${types_1.PortfolioMovementsOrderBy.CreatedBlockIdAsc}`;
    return (0, graphql_tag_1.default) `
  query PortfolioMovementsQuery
    ${args}
   {
    portfolioMovements(
      ${filter}
      orderBy: [${orderBy}]
    ) {
      nodes {
        id
        fromId
        toId
        asset {
          id
          ticker
        }
        amount
        address
        createdBlock {
          blockId
          datetime
          hash
        }
      }
    }
  }
`;
}
/**
 * @hidden
 *
 * Get Settlements where a Portfolio is involved
 */
function portfolioMovementsQuery(paddedIds, filters) {
    const { args, filter, variables } = createPortfolioMovementFilters(filters);
    const query = buildPortfolioMovementsQuery(paddedIds, args, filter);
    return {
        query,
        variables,
    };
}
exports.portfolioMovementsQuery = portfolioMovementsQuery;
/**
 * @hidden
 *
 * Get Settlements for all portfolios
 */
function portfoliosMovementsQuery(paddedIds, filters) {
    const { args, filter, variables } = createPortfolioMovementFilters(filters, true);
    const query = buildPortfolioMovementsQuery(paddedIds, args, filter);
    return {
        query,
        variables,
    };
}
exports.portfoliosMovementsQuery = portfoliosMovementsQuery;
//# sourceMappingURL=portfolios.js.map